import { lazy, Suspense } from 'react';
import { isRunningInAmpIFrame } from 'utils/injection';

const AMPIFrameResizer = lazy(() => import('./AMPIFrameResizer'));

export interface AMPIFrameResizerContainerProps {}

const AMPIFrameResizerContainer: React.FC<
  AMPIFrameResizerContainerProps
> = () => {
  return (
    <Suspense fallback={null}>
      {isRunningInAmpIFrame() ? <AMPIFrameResizer /> : null}
    </Suspense>
  );
};

export default AMPIFrameResizerContainer;
